import { Component, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NotificationService } from "../../../../../../../src/app/admin/services/notification.service";
import { ShareService } from "../../../../../../../src/app/admin/services/share.service";
import { Map } from '../../../../../../../src/app/admin/map_api/map'
import { LatLon } from "../../../../../../../src/app/admin/map_api/latlon";
import { ApiserviceService } from "../../../../../../../src/app/apiservice.service";
import { environment } from "../../../../../../../src/environments/environment";



@Component({
    selector: 'property-map',
    templateUrl: './property-map.html',
    styleUrls: ['../../legacy-component.component.css']
  })
  
  export class PropertyMap {
    google: any;
    map: Map;
    marker: any;
    loader_map: boolean = false;
    location: any = {
      lat: '',
      lon: ''
    };
    selected_assignment:any;
    @ViewChild('gmap') gmapElement: any;
    constructor(public dialogRef: MatDialogRef<PropertyMap>,
      @Inject(MAT_DIALOG_DATA) public data: any, private readonly api: ApiserviceService, private readonly share:ShareService, private readonly notify: NotificationService) {
      this.location.lat = this.data.parent.selected_property.lat;
      this.location.lon = this.data.parent.selected_property.lon;
      this.selected_assignment = this.share.csv_obj.selected_assignment;
    }
  
    ngAfterViewInit() {
      this.renderMap();
    }
  
    renderMap() {
      let location_obj: any = new LatLon(this.location.lat, this.location.lon, 0);
      let mapProp = {
        center: new LatLon(this.location.lat, this.location.lon, 0),
        zoom: 14,
        zoomControl: false,
        scaleControl: false,
        streetViewControl: false,
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        element: this.gmapElement.nativeElement
      };
  
      this.map = new Map(mapProp);
      //remove all markers
  
      this.map.removeAllMarkers();
      this.map.panTo(location_obj);
  
      this.map.addMarker(new LatLon(this.location.lat, this.location.lon, 0),
        {
          'iconUrl': '../assets/icon/Pin.svg',
          'iconWidth': 50,
          'iconHeight': 50
        }, false);
  
      this.data.parent.filteredPropertyList.forEach(prop => {
        this.map.addMarker(new LatLon(prop.lat, prop.lon, 0),
          {
            'iconUrl': '../assets/icon/Pin1.svg',
            'iconWidth': 25,
            'iconHeight': 25,
            'info': '<div id="content">' +
          prop.property_uid +
          '</div>',
          }, false);
  
      });
  
      if(this.selected_assignment){
        this.map.addGeoLayer({
          'format': 'wms',
          'layerName': 'parcels',
          'name': 'parcels',
          'url': environment.geoestater+'wms-layer',
          'assignment': this.selected_assignment,
          'city_code': this.api.city_code,
          'city_id': this.api.city_id,
          'user_token': environment.user_token
        });
  
      }else{
        this.notify.notify('Please select assignment for show the parcel layer', 'warn', 3000)
      }
  
    }
  }
  
  
  